var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgPlaybtn = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 48 48" }, props, { children: _jsx("path", { fill: "currentColor", d: "M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0m-2.6 14.667a1 1 0 0 0-1.574.82v17.131a1 1 0 0 0 1.535.845l12.849-8.138a1 1 0 0 0 .038-1.664z", opacity: 0.95 }) }))); };
export default SvgPlaybtn;
